<div class="modal-content bg-color">
  <div>
    <span class="top-left-title-bar">Error Report</span>
    <button (click)="closeModal()" type="button" class="close mr-4 mt-3" aria-label="Close"
            style="outline: none !important;">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-message-body">

    <p>
      {{message}}
    </p>
    <div class="main-table m-datatable m-datatable--default m-datatable--loaded w-100" id='errorTable' #errorTable>

      <table class="box-padding full-width table-fixed table-shade">
        <thead>
        <tr *ngFor="let err of result; let i = index;"
            [className]="i % 2 ==0 ? 'tr-height td-style-2 k-cursor-pointer card-color-even tr-height'
        : 'tr-height td-style-2 k-cursor-pointer card-color-odd tr-height'">

          <td class="pl-2" style="font-family: var(--font); font-weight: bold;">{{err.availability}}</td>

        </tr>
        </thead>

      </table>

    </div>
    <div class="modal-footer row justify-content-end" style="border:none">
    <button type="button" class="cancel-button" (click)="closeModal()"> Cancel </button>
    </div>
  </div>
</div>
